import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { SelectCustom } from '../../../../common/selectCustom'
import { COMPANY_TYPES } from '../../../../utils/common'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { RANK_BY } from './constant'
import classes from './index.module.scss'
import { changeRankBy, selectRankBy } from './store/slice'

export const RankBy = () => {
  const dispatch = useDispatch()

  const rankBy = useSelector(selectRankBy)
  const { companyType } = useSelector(selectCompanyInfo)

  const chooseRankByItem = (item) => {
    dispatch(changeRankBy(item))
  }

  const getLabelByCompanyType = (item) => {
    if (
      companyType === COMPANY_TYPES.CORPORATE &&
      item.value === RANK_BY.netRevenue.value
    ) {
      return item.corpLabel
    } else if (
      [COMPANY_TYPES.LIFE_INSURANCE, COMPANY_TYPES.NON_LIFE_INSURANCE].includes(
        companyType,
      ) &&
      item.value === RANK_BY.netRevenue.value
    ) {
      return item.lifeInsLabel
    } else {
      return item.label
    }
  }

  return (
    <Element
      className={classes.item}
      style={{ borderRight: '1px solid #9c9c9c' }}
    >
      <Translate value="industryOverview.topIndustryPlayers.RANK_BY" />
      <SelectCustom
        isBorderNone
        className="fw600"
        data={Object.values(RANK_BY).map((item) => ({
          ...item,
          label: getLabelByCompanyType(item),
        }))}
        activeItem={rankBy}
        isI18n
        chooseItem={chooseRankByItem}
      />
    </Element>
  )
}
